import { Components, Theme } from '@mui/material';
import { wbColors as colors, wbTheme } from '@workbuzz/shared-ui';
import { PAGE_BACKGROUND, WHITE } from 'app/theme/colors';

export const WORKBUZZ_SCROLLBAR_CLASS = 'workbuzz-scrollbar';

const SCROLLBAR_SELECTOR = `.${WORKBUZZ_SCROLLBAR_CLASS}`;

export const MuiCssBaselineStyles: Components<Omit<Theme, 'components'>> = {
  MuiCssBaseline: {
    styleOverrides: () => ({
      body: {
        fontFamily: wbTheme.typography.fontFamily,
        backgroundColor: PAGE_BACKGROUND,
        '@media print': {
          backgroundColor: WHITE,
        },
      },
      [`${SCROLLBAR_SELECTOR}`]: {
        '&::-webkit-scrollbar': {
          width: 8,
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: colors.eastBay,
          borderRadius: 4,
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: colors.bermudaGray,
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: colors.ghost,
          borderRadius: 4,
        },
      },
    }),
  },
};
